module.exports = __webpack_public_path__ + "static/img/HT_H5.2985fe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HT_H5.png
// module id = Tivz
// module chunks = 34